@if(list.length > 0) {
    <div class="container mt-3 pb-5">
      <mdb-accordion [borderless]="true" class="accordion--deleted-options">
        <mdb-accordion-item>
          <ng-template mdbAccordionItemHeader>Deleted Options ({{list.length}})</ng-template>
          <ng-template mdbAccordionItemBody>
            <div class="d-flex align-items-center justify-content-end mr-3">
              <div class="card__right-side d-flex justify-content-end search">
                <div class="search__icon-wrapper">
                  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <title>Icons/search</title>
                      <defs>
                          <rect id="path-1" x="0" y="0" width="726" height="404" rx="8"></rect>
                          <filter id="filter-3">
                              <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                          </filter>
                      </defs>
                      <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="Large" transform="translate(-858.000000, -165.000000)">
                              <rect fill="#f1f1f1" x="0" y="0" width="1024" height="882"></rect>
                              <g id="Card" transform="translate(274.000000, 150.000000)">
                                  <mask id="mask-2" fill="white">
                                      <use xlink:href="#path-1"></use>
                                  </mask>
                                  <g id="Rectangle"></g>
                              </g>
                              <g id="Icons/search" transform="translate(858.000000, 165.000000)">
                                  <g filter="url(#filter-3)" id="Color">
                                      <g>
                                          <path d="M8.05514748,-6.92779167e-14 C3.61630998,-6.92779167e-14 0,3.61627943 0,8.05514748 C0,12.4939989 3.61630443,16.1103033 8.05514748,16.1103033 C9.97490799,16.1103033 11.7382908,15.4316646 13.1243348,14.3048316 L18.5754498,19.755941 C18.9008413,20.0813298 19.4305328,20.0813576 19.7559438,19.755941 C20.0813521,19.4305245 20.0813521,18.9095246 19.7559438,18.5841359 L14.3048316,13.1330265 C15.4339396,11.7462769 16.110295,9.97705522 16.110295,8.05514748 C16.110295,3.61627943 12.4939878,-6.92779167e-14 8.05514748,-6.92779167e-14 Z M8.05514748,1.66658281 C11.5932936,1.66658281 14.4437122,4.51697637 14.4437122,8.05514748 C14.4437122,11.5932769 11.593288,14.4437205 8.05514748,14.4437205 C4.51700692,14.4437205 1.66658281,11.5932769 1.66658281,8.05514748 C1.66658281,4.51697637 4.51700137,1.66658281 8.05514748,1.66658281 Z" id="search" fill="#000000" fill-rule="nonzero"></path>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </svg>
                </div>
                <input [formControl]="search" class="form-control--search" placeholder="Search" />
                <div class="search__icon-wrapper--cross px-1">
                  <span class="cursor-pointer" *ngIf="search.value.length > 0" (click)="resetSearch()">X</span>
                </div>
              </div>
            </div>

            @for(option of filteredList; track option) {
              <app-campaign-deleted-option-element [option]="option"></app-campaign-deleted-option-element>
            }
          </ng-template>
        </mdb-accordion-item>
      </mdb-accordion>
    </div>
  }